export enum ToggleDirections {
  LEFT = 'left',
  RIGHT = 'right'
}
